<template>
    <b-row>
        <b-col cols="12" lg="10">
            <b-row>
                <b-col cols="12" md="3" class="text-center text-md-left mb-3 d-md-flex align-items-end">
                    <div class="d-inline-block text-left dt-block">
                        <p class="mb-1">{{$t("sensors-page.analysis-modal.from-date")}}</p>
                        <DatePicker @validate="SET_REPORTS_START_DATE" :date="GET_REPORTS_START_DATE"/>
                    </div>
                </b-col>
                <b-col cols="12" md="3" class="text-center text-md-left mb-3 d-md-flex align-items-end">
                    <div class="d-inline-block text-left dt-block">
                        <p class="mb-1">{{$t("sensors-page.analysis-modal.to-date")}}</p>
                        <DatePicker @validate="SET_REPORTS_END_DATE" :date="GET_REPORTS_END_DATE"/>
                    </div>
                </b-col>
                <b-col cols="12" md="3" class="text-center text-md-left mb-3 d-md-flex align-items-end">
                    <ReportsDropDown
                        :label="$t('dashboard.dam')"
                        :fields="damNamesArray"
                        :placeholder="$t('dashboard.choose')"
                        @change="selected"
                    />
                </b-col>
                <b-col cols="12" md="3" class="text-center text-md-left mb-3 d-md-flex align-items-end">
                    <WhiteIconButton
                        :class="['dt-block', 'm-md-1', 'm-auto', 'filter']"
                        :text="$t('reports.send')"
                        :hideTextMobile="false"
                        icon="filter"
                        :emit-this="'submit-data'"
                        v-on:submit-data="emitAndResetPageNumber"
                    ></WhiteIconButton>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script>
    // vuex
    import {mapActions, mapGetters} from "vuex";
    import {
        GET_REPORTS_START_DATE,
        SET_REPORTS_START_DATE,
        GET_REPORTS_END_DATE,
        SET_REPORTS_END_DATE
    } from "../../store/actions/date-time";
    import {
        SET_SELECTED_DAMS,
        GET_SELECTED_DAMS,
        SET_PAGINATION_PAGE
    } from "../../store/actions/reports";
    import {GET_PS_DATA} from "../../store/actions/dashboard";
    // constants
    import {initPage} from "../../constants/report-constants";
    // components
    import DatePicker from "../shared/DatePicker";
    import ReportsDropDown from "./ReportsDropDown";
    import WhiteIconButton from "../shared/WhiteIconButton";

    export default {
        name: "ReportsActionBar",
        components: {
            DatePicker,
            ReportsDropDown,
            WhiteIconButton
        },
        async mounted() {
            await this.SET_SELECTED_DAMS([]);  //reset selected dams
            await this.GET_PS_DATA();
        },
        computed: {
            ...mapGetters([
                GET_REPORTS_START_DATE,
                GET_REPORTS_END_DATE,
                'getPsData',
                GET_SELECTED_DAMS
            ]),
            damNamesArray() {
                if (Object.keys(this.getPsData).length > 0) {
                    return this.getPsData['PS_stations'].map(el => {
                        return {
                            visible: true,
                            label: this.$i18n.locale === 'en' ? el[0] : el[6],
                            value: el[0]
                        }
                    });
                }
                return [];
            },
        },
        methods: {
            ...mapActions([
                SET_REPORTS_START_DATE,
                SET_REPORTS_END_DATE,
                GET_PS_DATA,
                SET_SELECTED_DAMS,
                SET_PAGINATION_PAGE
            ]),
            selected(selectedArr) {
                this.SET_SELECTED_DAMS(selectedArr);
            },
            emitAndResetPageNumber() {
                this.SET_PAGINATION_PAGE(initPage);
                this.$emit('do-query', initPage);
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/variables";

    .dt-block {
        width: 100%;
        max-width: $dt-pk-width;
    }

    .filter {
        @include media-breakpoint-up(md) {
            max-width: 136px;
        }
    }
</style>